import ActionTypes from '../constants/ActionTypes';

const initializeCore = (
  user,
  board,
  users,
  projects,
  projectManagers,
  boards,
  boardMemberships,
  labels,
  lists,
  cards,
  cardMemberships,
  cardLabels,
  tasks,
  attachments,
  activities,
  notifications,
  // FAMILY-EXT: feature 1+2
  cardWaitingActions,
) => ({
  type: ActionTypes.CORE_INITIALIZE,
  payload: {
    user,
    board,
    users,
    projects,
    projectManagers,
    boards,
    boardMemberships,
    labels,
    lists,
    cards,
    cardMemberships,
    cardLabels,
    tasks,
    attachments,
    activities,
    notifications,
    // FAMILY-EXT
    cardWaitingActions,
  },
});

// TODO: with success?
initializeCore.fetchConfig = (config) => ({
  type: ActionTypes.CORE_INITIALIZE__CONFIG_FETCH,
  payload: {
    config,
  },
});

const logout = (invalidateAccessToken) => ({
  type: ActionTypes.LOGOUT,
  payload: {
    invalidateAccessToken,
  },
});

logout.invalidateAccessToken = () => ({
  type: ActionTypes.LOGOUT__ACCESS_TOKEN_INVALIDATE,
  payload: {},
});

// FAMILY-EXT: матрица Эйзенхауэра — picker квадранта при дропе на границу.
const showEisenhowerPicker = (cardId, options) => ({
  type: ActionTypes.EISENHOWER_PICKER_SHOW,
  payload: { cardId, options },
});

const hideEisenhowerPicker = () => ({
  type: ActionTypes.EISENHOWER_PICKER_HIDE,
  payload: {},
});

export default {
  initializeCore,
  logout,
  showEisenhowerPicker,
  hideEisenhowerPicker,
};
